import { keyframes } from 'styled-components';

export const closeDrawerKeyframes = {
  top: keyframes`
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(0, -100vh, 0);
    }
  `,
  bottom: keyframes`
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(0, 100vh, 0);
    }
  `,
  left: keyframes`
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(-100vw, 0, 0);
    }
  `,
  right: keyframes`
    from {
      transform: perspective(50px) translate3d(0, 0, 0);
    }
    to {
      transform: perspective(50px) translate3d(100vw, 0, -200px);
    }
  `,
};

export const openDrawerKeyframes = {
  top: keyframes`
    from {
      transform: translate3d(0, -100vh, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  `,
  bottom: keyframes`
    from {
      transform: translate3d(0, 100vh, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  `,
  left: keyframes`
    from {
      transform: translate3d(-100vw, 0, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  `,
  right: keyframes`
    from {
      transform: perspective(50px) translate3d(100vw, 0, -200px);
    }
    to {
      transform: perspective(50px) translate3d(0, 0, 0);
    }
  `,
};

export const backgroundFadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const backgroundFadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const drawerPositions = {
  top: {
    bottom: 'auto',
    left: 0,
    right: 0,
    top: 0,
  },
  bottom: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 'auto',
  },
  left: {
    left: 0,
    right: 'auto',
  },
  right: {
    left: 'auto',
    right: 0,
    transformOrigin: '100% 5%',
  },
};
